namespace advisorop.domains {
    "use strict";

    export interface IInvestorAdvisor {
        advisorId?: number;
        advisor?: domains.IAdvisor;
        investorId?: number;
        // use enum RelationType to assign values
        relationType?: number;

        relationTypeDescription?: string;
    }

    export interface IAdvisorInvestorRelations {
        advisor?: domains.IAdvisor;
        relationType?: domains.RelationType;
    }

    export interface ISalesforceAnalystData {
        salesforceUserId?: string;
        firstName?: string;
        lastName?: string;
        email?: string;
        phone?: string;
        title?: string;
        department?: string;
        lastSyncedAt?: Date;
    }

    export interface IInvestor {

        id?: number;

        // 0-individual, 1-company
        investorType?: domains.InvestorType;
        primaryInvestor?: boolean;
        minorInvestor?: boolean;
        investorTypeDescription?: string;

        firstName?: string;

        middleName?: string;

        lastName?: string;

        entityName?: string;

        entityType?: domains.EntityType;

        trustDate?: Date;

        trustType?: domains.TrustType;

        fullName?: string;

        tin?: string;

        tinForPublic?: string;

        streetAddress1?: string;

        streetAddress2?: string;

        mailingAddress1?: string;

        mailingAddress2?: string;

        streetAddressSameAsMailingAddress?: boolean;

        streetCity?: string;

        mailingCity?: string;

        streetState?: string;

        streetStateFormat?: domains.StateFormat;

        mailingState?: string;

        mailingStateFormat?: domains.StateFormat;

        streetPostCode?: string;

        mailingPostCode?: string;

        streetCountryId?: string;

        mailingCountryId?: string;

        fullAddress?: string;

        employmentStatus?: number;

        employmentStatusDescription?: string;

        employerName?: string;

        employmentStartDate?: Date;

        occupation?: string;

        employerAddress1?: string;

        employerAddress2?: string;

        employerCity?: string;

        employerState?: string;

        employerStateFormat?: domains.StateFormat;

        employerPostCode?: string;

        employerCountryId?: string;

        contactFirstName?: string;

        contactLastName?: string;

        contactFullName?: string;

        useEmailAsUsername?: boolean;

        contactEmail?: string;

        contactPhone?: string;

        businessPhone?: string;

        mobilePhone?: string;

        // use enum RecordStatus
        recordStatus?: number;

        statusDescription?: string;

        dateOfBirth?: Date;

        maritalStatus?: number;

        maritalStatusDescription?: string;

        gender?: number;

        genderDescription?: string;

        dateCreated?: Date;

        dateChanged?: Date;

        redTailId?: string;

        extId?: string;

        // advisoryType?: domains.RelationType;

        advisors?: Array<domains.IInvestorAdvisor>;

        secondaryAdvisors?: Array<domains.IInvestorAdvisor>;

        systemLogin?: domains.identity.IUser;

        companyGroup?: domains.ICompanyGroup;

        households?: Array<domains.IHousehold>;

        usCitizenshipStatus?: number;

        usCitizenshipStatusDescription?: string;

        citizenship?: string;

        employeeAnotherIBD?: boolean;

        relEmployeeAnotherIBD?: boolean;

        publicCoAffiliation?: boolean;

        legalTaxResidence?: string;

        vulnerableAdult?: boolean;

        trustedContacts?: Array<domains.ITrustedContact>;

        loginOptions?: Array<domains.IInvestorLoginOption>;
       // advisors?: Array<domains.IInvestorAdvisor>;

        loginCount?: number;
    }

    export interface IInvestorAndLink {
        investor?: IInvestor;
        link?: string;
    }

    export interface IInvestorLoginOption {
        id?: number;
        type?: LovType;
        option?: number;
        value?: number;
    }

    export interface ITrustedContact {
        id?: number;

        investorId?: number;

        firstName?: string;
        middleName?: string;
        lastName?: string;

        dateOfBirth?: Date;

        email?: string;

        mobilePhone?: string;

        contactPhone?: string;

        businessPhone?: string;

        //Mailing address

        mailingAddress1?: string;

        mailingAddress2?: string;

        mailingCity?: string;

        mailingState?: string;

        mailingPostCode?: string;

        mailingCountryId?: string;

        recordStatus?: domains.RecordStatus;

        relationshipType?: domains.TitleInvestorRelationType;

        relTypeStr?: string;
    }
    export interface IHousehold {

        id?: number;

        name?: string;

        //Mailing address

        mailingAddress1?: string;

        mailingAddress2?: string;

        mailingCity?: string;

        mailingState?: string;

        mailingPostCode?: string;

        mailingCountryId?: string;

        //#########################

        accountGroupView?: AccountGroupView;

        defaultAccountGroupView?: AccountGroupView;

        hasAdvisoryDefinedGroup?: boolean;

        usdMarketValue?: number;

        investors?: Array<IInvestor>;

        companyGroupId?: number;

        advisoryFirmId?: number;

        rtgs?: Array<domains.IAccountGroup>;

        companyGroup?: domains.CompanyGroup;

        advisoryFirm?: domains.IAdvisoryFirm;

        recordStatus?: domains.RecordStatus;
    }

    export interface ISearchInvestorHouseholdResults {
        id?: number;
        menuName?: string;
        name?: string;
        entityType?: number;
        advisorId?: number;
    }

    export interface ISearchAccountResults {
        number?: string;
        accountId?: number;
        householdId?: number;
        advisorId?: number;
        accountDescription?: string;
        investmentType?: domains.InvestmentType;
    }

    export interface ITitle {
        id?: number;

        name?: string;

        titleType?: number;

        companyGroupId?: number;

        accounts?: Array<IAccount>;

        investors?: Array<ITitleInvestor>;

        companyGroup?: ICompanyGroup;
    }

    export interface ITitleInvestor {
        id?: number;

        titleId?: number;

        titleName?: string;

        investorId ?: number;

        relationType?: number;

        investor?: domains.IInvestor;
    }

    export interface IAccount {
        
        id?: number;

        advisoryFirmId?: number;

        name?: string;

        updateFrequency?: number;

        number?: string;

        //ppAccountId?: number;

        titleId?: number;

        titleType?: domains.TitleType;

        titleSubtype?: number;

        accountType?: domains.InvestmentType;

        accountTypeDescription?: string;
        
        operationalType?: domains.OperationalType;

        operationalTypeDescription?: string;

        tampId?: number;

        docRequests?: Array<domains.IAccountDocRequest>;

        fundingComponents?: Array<domains.IAccountFundingComponent>;

        investmentAmount?: number;

        managerId?: number;

        productId?: number;

        company?: string;

        productDescription?: string;

        directManagerDesc?: string;

        directManagerProductDesc?: string;

        tampType?: domains.TampType;

        tampTypeDescription?: string;

        tampName?: string;

        productTypeId?: domains.ProductType;

        notes?: string;

        isDiscretionDocumentationOnFile?: boolean;
        isNumberReserved?: boolean;
        isDocumentationSent?: boolean;
        isOpenAccountRequested?: boolean;

        fees?: boolean;

        titleTypeDescription?: string;

        advisoryFirmMgtRole?: domains.AdvisoryFirmMgtRole;

        advisoryFirmMgtRoleDescription?: string;

        titleSubtypeDescription?: string;

        usdMarketValue?: number;

        marketValueDate?: Date;

        status?: number;

        statusDescription?: string;

        dateCreated?: Date;

        dateChanged?: Date;
        holdingsMaintaindExSystem?: boolean;

        repFeeGroupId?: number;

        titleName?: string;

        advisoryFee?: number;

        manualAccount?: domains.IManualAccount;

        isManualAccount?: string;

        advisoryFirm?: domains.IAdvisoryFirm;

        investors?: Array<domains.IInvestor>;

        rtgs?: Array<domains.IAccountGroupAccount>;

        repFeeGroup?: domains.IRepFeeGroup;

        proposal?: IProposal;

        custodianId?: number;

        custodianName?: string;

        officeRangeId?: number;

        officeRangeDescription?: string;

        tempHouseholdGroup?: number;

        hasCustodian?: boolean;

        // supplemental fields for Perhsing
        nonUSOfficial?: boolean;
        privateBankAccount?: boolean;
        foreignBankAccount?: boolean;
        sourceOfInitialFunds?: string;
        sweepStatus?: string;
        sweepId?: string;
        sweepFundsPercent?: number;
        redemptionPriority?: boolean;
        marginDebtIndicator?: boolean;
        confirmSuppression?: boolean;
        pricingType?: domains.PricingType;
        brokerageType?: domains.BrokerageType;
        
        isNewCustodianAccount?: boolean;
        custodianAccountId?: number;

        // client-only attribute that allows us to clone account details on the server
        // e.g. if we want to create a new account that copies heavily from an existing account
        // e.g. in the case where we create custodian accounts and copy most of the account details from an existing account record.
        cloneAccountId?: number;

        // Required by Pershing for certain title types
        jointAgreementExecDate?: Date;

        // Required by Pershing for Custodian account title types
        custStateGiftGiven?: string;
        custDateGiftGiven?: Date;
        custMannerOfGift?: number;
        custAgeTermination?: number;

        // If account is being established for a foreign bank, then this field
        // (is the bank a central bank) is required be Pershing.
        centralBankAcctInd?: boolean;
        foreignFinInstInd?: boolean;

        usOfficialFirstName?: string;
        usOfficialLastName?: string;
        usOfficialOfficeHeld?: string;
        usOfficialOfficeCountry?: string;

        initialFundsOtherText?: string;

        jointTenancyState?: string;
        jointHoldersMarried?: boolean;

        lastExported?: Date;

        setupCreationType?: domains.AccountCreationType;
        setupCustodianId?: number;
        setupRelatedAccountId?: number;
        setupDirectAccountFlag?: boolean;

        extApiTransmitted?: boolean;

        extApiTransmittedStr?: string;

        accountPurpose?: number;
        accountPurposeOtherText?: string;

        accountBeneficiaries?: IAccountBeneficiary[];

        custodianSubAccounts?: IAccount[];

    }

    export interface IAccountDocRequest {
        id?: number;
        accountId?: number;
        documentType?: domains.DocumentType;
        dateNeeded?: Date;
        deliveryMethod?: domains.DocumentDeliveryMethod;
    }

    export interface IAccountFundingComponent {
        id?: number;
        accountId?: number;
        amount?: number;
        fundingSource?: domains.FundingSource;
        fundingSourceName?: string;  
    }

    export interface IAccountCreationShortcut {
        shortcutType: domains.AccountCreationShortcutType;
        shortcutId: number;
        description: string;
    }

    export interface IAccountBeneficiary {
        id?: number;
        accountId?: number;
        beneficiaryType?: BeneficiaryType;
        percentAllocation?: number;
        investorId?: number;
        relationshipType?: RelationshipType;
        individualType?: IndividualType;
        gender?: Gender;
        countryCitizenIncorp?: string;
        dateOfBirth?: Date;
        tin?: string;
        tinForPublic?: string;
        entityName?: string;
        firstName?: string;
        lastName?: string;
        recordStatus?: RecordStatus;

        investor?: IInvestor;
        genderLov?: ILOV;
        countryCitizenIncorpLov?: ILOV;
        beneficiaryTypeLov?: ILOV;
        relationTypeLov?: ILOV;
        individualTypeLov?: ILOV;
    }

    export interface IManager {
        id?: number;
        name?: string;
        status?: domains.Status;
        statusDescription?: string;
    }

    export interface ITamp {
        id?: number;
        name?: string;
        type?: number;
    }

    export interface IAdvisoryFirmTamp {
        id?: number;
        advisoryFirmId?: number;
        tampId?: number;
        tampName?: string;
        assignedStatus?: boolean;
        assignedStatusDescription?: string;
        tampType?: TampType;
        tampTypeName?: string;
    }

    export interface IManagerProductType {
        id?: number;
        managerId?: number;
        productTypeId?: number;
        productTypeName?: string;
        status?: domains.Status;
        statusDescription?: string;
        managerName?: string;
        contactFirstName?: string;
        contactLastName?: string;
        contactAddress?: string;
    }

    export interface IAdvisoryFirmManager {
        id?: number;
        advisoryFirmId?: number;
        managerId?: number;
        managerName?: string;
    }

    export interface IAdvisoryFirmProductType {
        id?: number;
        advisoryFirmId?: number;
        managerProductTypeId?: number;
        productTypeId?: number;
        contactFirstName?: string;
        contactLastName?: string;
        contactAddress?: string;
        productTypeName?: string;
        managerId?: number;
        managerName?: string;
        products?: Array<IAdvisoryFirmProduct>;
    }

    export interface IAdvisoryFirmProduct {
        id?: number;
        advisoryFirmId?: number;
        managerProductId?: number;
        name?: string;
        productAccess?: domains.ProductAccess;
        productTypeId?: number;
        productStatusDescription?: string;
        status?: domains.Status;
        managerFee?: number;
        productTypeName?: string;
        managerId?: number;
        managerName?: string;
        dataSource?: DataSource;
        subDataSource?: number;
        tamps?: Array<domains.ITampProduct>;
        compensationType?: domains.CompensationType;
        commissionRate?: number;
        advisoryFee?: number;
        minimumInvestmentAmmount?: number;
        riskBase?: domains.RiskBases;
        orionEclipseModelId?: number;
    }

    export interface IReportTemplate {
        id?: number;
        platform?: ReportingPlatform;
        uid?: string;
        name?: string;
        platformDescription?: string;
        documentType?: DocumentType;
    }

    export interface IManagerProduct {
        id?: number;
        managerProductTypeId?: number;
        name?: string;
        productTypeId?: number;
        productTypeName?: string;
        managerId?: number;
        status?: domains.Status;
        statusDescription?: string;
        managerName?: string;
        annuityType?: domains.AnnuityType;
        annuitySubtype?: domains.AnnuitySubtype;
        annuityTypeDescription?: string;
        annuitySubtypeDescription?: string;
        reportTemplateId?: number;
        reportTemplateName?: string;
        reportTemplateUid?: string;
        reportTemplatePlatform?: ReportingPlatform;
        reportTemplatePlatformDescription?: string;
        externalSystem?: number;
        externalSystemId?: number;
        firmProducts?: Array<IAdvisoryFirmProduct>;
        styleBased?: boolean;
        minEquity?: number;
        maxEquity?: number;
    }

    export interface ITampProduct {
        id?: number;
        advisoryFirmId?: number;
        tampId?: number;
        advisoryFirmProductId?: number;
        productName?: string;
        productTypeName?: string;
        managerName?: string;
    }

    export interface ILinkType {
        id?: number;
        categoryName?: string;
        forward?: string;
        reverse?: string;
        forIndividuals?: boolean;
        forEntities?: boolean;
    }

    export interface ILink {
        id?: number;
        firstEntityId?: number;
        firstEntityName?: string;
        secondEntityId?: number;
        secondEntityName?: string;
        linkTypeId?: number;
        linkTypeDescription?: string;
        categoryName?: string;
        idUserId?: string;
    }

    export interface ISecurityAssetClass {
        securityAllocationPlanId?: number;
        securityId?: number;
        securityUniqueSecId?: string;
        securityTicker?: string;
        securityName?: string;
        securitySecurityType?: string;
        securitySecurityCategory?: string;
        equities?: number;
        fixedIncome?: number;
        alternativeAssets?: number;
        cash?: number;
        noAllocation?: number;
        minEquity?: number;
        maxEquity?: number;
    }

    export interface AFAssetClassClassnsAlloc {
        afAssetClassnClassnId: number;
        allocationPercentage: number;
    }

    export interface IAFSecurityAssetClass {
        afSecurityAllocationPlanId?: number;
        securityId?: number;
        securityUniqueSecId?: string;
        securityTicker?: string;
        securityName?: string;
        securitySecurityType?: string;
        securitySecurityCategory?: string;
        assetClassAllocations?: AFAssetClassClassnsAlloc[];
    }

    export interface ISecurityAllocationPlan {
        id?: number;
        advisoryFirmId?: number;
        name?: string;
        allocationPlanType?: AllocationPlanType;
        styleBased?: boolean;
        allocations?: ISecurityAssetClass[];
    }

    export interface IAFSecurityAllocationPlan {
        id?: number;
        advisoryFirmId?: number;
        name?: string;
        afAssetClassnModelId?: number;
        isActive?: boolean;
        //allocationPlanType?: AllocationPlanType;
        //styleBased?: boolean;
        allocations?: IAFSecurityAssetClass[];
    }

    export interface ISecurityNoteUnderlying {
        asOfDate?: Date
        underlyingReturn?: number
        percentToBreach?: number
        breached?: boolean
    }

    export interface ISecurityNoteValuation {
        asOfDate?: Date;
        couponType: string;
        costBasis?: number;
        valuation?: number;
        couponSummary: string;
        couponProbability?: number;
        couponsRemaining?: number;
        callProbability?: number;
        nextObservationDate?: Date;
        annualizedYield?: number;
        finalValuationDate?: Date;
        fixedParticipation?: number;
        noteReturn?: number;
        realizedMaturityValue?: number;
        fixedCoupon?: number;
        participationPlus?: number;
    }

    export interface ISecurityNotePortfolio {
        asOfDate?: Date;
        notional?: number;
        unrealizedGainLoss?: number;
        marketValue?: number;
        annualCouponIfPaid?: number;
        couponAmount?: number;
    }

    export interface ISecurityNoteAsOf {
        asOfDate?: Date;
        matureTodayReturnAtMaturity?: number;
        matureTodayValueAtMaturity?: number;
    }

    export interface ISecurityNote {
        uniqueSecId: string;
        cusip?: string;
        shortName: string;
        noteClass: string;
        issuerName: string;
        currency: string;
        termMonths?: number;
        issueDate?: Date;
        maturityDate?: Date;
        timeRemainingMonths?: number;
        securityNoteUnderlying?: ISecurityNoteUnderlying;
        securityNoteValuation?: ISecurityNoteValuation;
        securityNotePortfolo?: ISecurityNotePortfolio;
        securityNoteAsOf?: ISecurityNoteAsOf;
    }

    export interface IHDAccount {
        householdId?: number;
        householdName?: string;
        groupId?: number;
        groupName?: string;
        groupType?: AccountGroupType;
        groupTypeDescription?: string;
        rtqId?: number;
        rtqDescription?: string;
        rtqScore?: number;
        rtId?: number;
        rtName?: string;
        investorId?: number;
        investorName?: string;
        accountNumber?: string;
        accountName?: string;
        accountType?: InvestmentType;
        titleType?: number;
        titleTypeDescription?: string;
        titleSubtype?: number;
        titleSubtypeDescription?: string;
        accountStatus?: number;
        accountId?: number;
        modelID?: number;
        modelDescription?: string;
        boRtgId?: string;
        AccountTypeDescription?: string;
        securityAssetClass?: string;
        securityType?: string;
        securityCategory?: string;
        securitySymbol?: string;
        uSDMarketValue?: number;
        securityAllocationPlanId?: number;
        securityAllocationPlanName?: string;
        advisoryFirmMgtRole?: AdvisoryFirmMgtRole;
        custodianName?: string;
        level3Caption?: string;
        level2Caption?: string;
        groupDescription?: string;
        account?: IAccount;
        investorIds?: string;
        managerAndProduct?: string;
    }
}